import React from "react";
import styled from "styled-components";
import { FontSize, FontWeight, Radius } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import Tooltip from "@ui-kit/tooltip";
import { tr } from "@radarly/i18n";

interface IProps {
  locale: Locale;
  photoMentions: {
    mentions: {
      label: string;
      url: string;
    }[];
    color: string;
  };
}

const Root = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Label = styled.a<{ color: string }>`
  font-weight: ${FontWeight.Bold};
  color: ${({ color }) => color} !important;
  border: 1px solid ${({ color }) => color};
  border-radius: ${Radius.Small};
  background: transparent;
  margin: 4px 4px 0 0;
  font-size: ${FontSize.Medium};
  padding: 4px;
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
`;

export default function PhotoMentions({ photoMentions, locale }: IProps) {
  const { mentions, color } = photoMentions;
  return (
    <Root>
      {mentions.map((mention, i) => (
        <Tooltip tooltip={tr(locale, "RADARLY::POST::MENTION-IN-IMAGE")}>
          <Label
            key={i}
            color={color}
            href={mention.url}
            target="_blank"
            rel="noreferrer"
          >
            {mention.label}
          </Label>
        </Tooltip>
      ))}
    </Root>
  );
}
